export const LOYALTY_PURCHASE_POINTS_SUCCESS_SESSION_KEY = 'le:loyalty_purchase_points_success'

/** Max points purchasable in a single transaction (excludes bonus offers). */
export const LOYALTY_PURCHASE_POINTS_MAX_PER_TRANSACTION = 500_000

/** Max points purchasable in any rolling 12-month window (excludes bonus offers). */
export const LOYALTY_PURCHASE_POINTS_MAX_PER_WINDOW = 1_000_000
